import { PropsWithChildren } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { addTruckStopSchema, AddTruckStopSchemaProps } from "./truckStopSchema";

interface TruckStopFormProviderProps extends PropsWithChildren {
	defaultValues?: AddTruckStopSchemaProps;
}

const TruckStopFormProvider = ({ children, defaultValues }: TruckStopFormProviderProps) => {
	const formMethods = useForm({
		mode: "onSubmit",
		resolver: yupResolver(addTruckStopSchema),
		reValidateMode: "onChange",
		defaultValues: defaultValues
	});

	return <FormProvider {...formMethods}>{children}</FormProvider>;
};

export default TruckStopFormProvider;
